import { twcn } from '@web/ui/core/utils';

/**
 * RailCount — trailing count badge for sidebar rail rows.
 *
 * The number is centred inside a fixed-width slot (`w-5.5`, the xs
 * IconButton size) so every rail row's trailing element — count, hover
 * settings icon, section "+" — shares one column on the same right
 * edge. This is the single trailing-alignment contract; rows differ
 * only in their leading content.
 *
 * Inside a `group/row`, the number fades on hover/focus so a sibling
 * action can slot in over it without reflow. Rows that aren't a
 * `group/row` (NavigationRail leaves) never trigger the fade.
 */
export function RailCount({
  value,
  active,
}: Readonly<{ value: number; active: boolean }>): React.JSX.Element {
  return (
    <span className="inline-flex w-5.5 flex-shrink-0 items-center justify-center">
      <span
        className={twcn(
          'font-mono text-tiny tabular-nums transition-opacity duration-fast ease-standard',
          active ? 'text-primary' : 'text-faint-foreground',
          'group-hover/row:opacity-0 group-focus-within/row:opacity-0',
        )}
      >
        {value}
      </span>
    </span>
  );
}
